module.exports = __webpack_public_path__ + "img/orderManagementHeader.67c18544.svg";